<template>
  <div class="opera-cacheManger">
    <topNav :title="$t('cacheManger_title')"
            url='/opera/center' replace="true"></topNav>
    <mt-cell size="small"
             :title="$t('cacheManger_clearCloudAddress')"
             is-link
             @click.native="clearData('clearCloudAddress')"><span>
        {{$t('cacheManger_clear')}}</span></mt-cell>
    <mt-cell type="default"
             :title="$t('cacheManger_clearCloudParamCache')"
             is-link
             @click.native="clearData('clearCloudParamCache')"><span>{{$t('cacheManger_clear')}}</span></mt-cell>
    <mt-cell type="default"
             :title="$t('cacheManger_clearCloudWithoutUserInfo')"
             is-link
             @click.native="clearData('clearCloudWithoutUserInfo')">
      <span>{{$t('cacheManger_clear')}}</span>
    </mt-cell>

    <mt-cell size="small"
             :title="$t('cacheManger_clearAddress')"
             is-link
             @click.native="clearData('clearAddress')"><span>{{$t('cacheManger_clear')}}</span></mt-cell>
    <mt-cell type="default"
             :title="$t('cacheManger_clearParamCache')"
             is-link
             @click.native="clearData('clearParamCache')"><span>{{$t('cacheManger_clear')}}</span></mt-cell>
    <mt-cell type="default"
             :title="$t('cacheManger_clearAllWithoutUserInfo')"
             is-link
             @click.native="clearData('clearAllWithoutUserInfo')">
      <span>{{$t('cacheManger_clearAllWithoutUserInfo')}}</span>
    </mt-cell>
  </div>
</template>
<script>
  import {Toast, MessageBox} from 'mint-ui';

  export default {
    data() {
      return {}
    },
    mounted() {

    },
    methods: {
      clearData(method) {
        MessageBox.confirm('确定清除?').then(action => {
          this.$http.post('/mobilepmsapi/sys/' + method).then(res => {
            if (res.data.result == 0) {
              this.msg("清除成功");
            } else {
              this.msg(res.data.msg);
            }
          })
        }).catch();
      },
      msg(msg) {
        Toast({
          message: msg,
          position: 'bottom',
          duration: 3000
        });
      },
    },
    filters: {},
    components: {}
  }
</script>
<style lang='less'>
  .opera-cacheManger {
    height: 100%;

    button {
      margin: 10px auto;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// cacheMange.vue?7b4cef0d